import Page from '../../components/Page'
import React from 'react'

export default function AuthWrapper({
	children,
	siteConfig,
	title = '',
}) {
	return (
		<Page
			page="app-loan-officer-left"
			title={title}
			noDarkMode
			showFooter
			bgColor={siteConfig?.backgroundColor}
			bgImageUrl={siteConfig?.backgroundImageUrl}
		>
			<div className="flex justify-center items-center min-h-screen">
				<div className="rounded-lg flex self-center content-center bg-white my-5 dark:bg-slate-800">
					<div className="flex flex-col items-center justify-center w-full py-6 px-6 sm:pb-12 sm:pt-10 md:pt-12 sm:px-12">
						{children}
					</div>
				</div>
			</div>
		</Page>
	)
}
